{
  "it": {
    "baseSelect": {
      "homepageSetting": {
        "featuredModels": {
          "label": "Navi in evidenza",
          "nullablePrompt": "Nessuna nave in evidenza"
        }
      },
      "actions": {
        "fetchMore": "Carica altro"
      },
      "labels": {
        "search": "Scrivi per cercare",
        "nullablePrompt": "Nessuna opzione selezionata",
        "prompt": "Per favore seleziona un'opzione",
        "removeTooltip": "Clicca per rimuovere l'opzione"
      },
      "model": {
        "baseModel": {
          "label": "Modello base"
        }
      },
      "modelLoaner": {
        "loanerModel": {
          "label": "Modello in prestito"
        }
      },
      "modelSnubCraft": {
        "snubCraft": {
          "label": "Snub Craft",
          "prompt": "Seleziona uno Snub Craft"
        }
      },
      "modelPosition": {
        "positionType": {
          "label": "Tipo di posizione",
          "prompt": "Seleziona il tipo di posizione"
        },
        "source": {
          "label": "Fonte",
          "prompt": "Seleziona la fonte"
        }
      },
      "fleet": {
        "members": {
          "shipsFilter": {
            "label": "Filtro navi",
            "prompt": "Seleziona quali navi mostrare",
            "nullablePrompt": "Seleziona un'opzione"
          },
          "blueprintsFilter": {
            "label": "Filtro progetti",
            "prompt": "Scegli quali progetti condividere",
            "nullablePrompt": "Seleziona un'opzione"
          },
          "hangarGroupId": {
            "label": "Gruppo hangar",
            "prompt": "Seleziona un gruppo hangar",
            "nullablePrompt": "Seleziona un gruppo"
          }
        }
      }
    }
  }
}
